import React from 'react';
import { isEmpty, cloneDeep ,indexOf} from 'lodash';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';

import ACButton from '../../atoms/ACButton';
import ACMedia from '../../atoms/ACMedia';

import { getDefaultStoryboard } from '../../common/providers';
import { getMediaForUIName, getUIElementType, getUIElement } from '../../common/global';

import styles from './SetStoryboard.module.scss';
import ACStatus from '../../atoms/ACStatus';
import ACUIElement from '../../atoms/ACUIElement';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ACCategory from '../../atoms/ACCategory';

const endingKeys = ['type'];
const endingCallOutKeys = ['type', 'subType']
const dummyCategoryName = 'Unsorted';
const addNewCategorylabel = 'Add new category';

export default class SetStoryboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEnding: false,
      storyboard: getDefaultStoryboard(),
      selectedPoi:'',
      showPoiDropDown:false,
      newPoiCategory :addNewCategorylabel
    };

    this.onChangeStoryboardText = this.onChangeStoryboardText.bind(this);
    this.onSaveStoryboard = this.onSaveStoryboard.bind(this);
    this.setShowEnding = this.setShowEnding.bind(this);
    this.onChangePoi = this.onChangePoi.bind(this);
    this.onUpdateCategory = this.onUpdateCategory.bind(this);
    this.onDeleteSelectedPoi = this.onDeleteSelectedPoi.bind(this);
  }

  setShowEnding(storyboard){
    const { uiElements } = storyboard;
    const ending = getUIElement(uiElements, getUIElementType().ending);

    const endingCallOut = getUIElement(
      uiElements,
      getUIElementType().ending,
      getUIElementType().callOut
    );
    const endingKeysArr = Object.keys(ending).filter(field => !endingKeys.includes(field)).filter((ele) => ending[ele]);
    const endingCallOutKeysArr = Object.keys(endingCallOut).filter(field => !endingCallOutKeys.includes(field)).filter((ele) => endingCallOut[ele]);
    const shouldShowEndingCallout = endingKeysArr.length > 0 || endingCallOutKeysArr.length > 0;
    this.setState({showEnding: shouldShowEndingCallout})
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.storyboard && this.props.storyboard !== nextProps.storyboard) {

      // Internal update
      const { storyboard } = nextProps;
      // extract top media to ease later manipulation
      const medias = storyboard.medias || [];
      let media = medias.media || { type: 'image', url: '' };
      if (isEmpty(media.url) && !isEmpty(medias)) media = medias[medias.length - 1]; // Pick last element as most probable the latest
      storyboard.media = media;

      this.setState({
        storyboard: nextProps.storyboard,
      });
    }
  }

  componentDidMount(){
    const storyboard = this.props.storyboard;
    this.setShowEnding(storyboard);
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;
    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }

    const storyboard = this.props.storyboard;
    if(prevProps?.storyboard !== storyboard){
      this.setShowEnding(storyboard);
    }
  }

  updateMedia(media) {
    const { storyboard = {} } = cloneDeep(this.state);
    const { name, url } = media;
    let uiElement = {};
    let uiEleMedia = {};
    switch (name) {
      case 'callOut':
        uiElement = getUIElement(storyboard.uiElements, getUIElementType().callOut);
        if (isEmpty(uiElement)) return;
        uiEleMedia = uiElement.media || {};
        uiEleMedia.url = url;
        uiElement.media = uiEleMedia;
        this.updateStoryboardUIElementData(cloneDeep(uiElement));
        break;
      case 'endingCallOut':
        uiElement = getUIElement(
          storyboard.uiElements,
          getUIElementType().ending,
          getUIElementType().callOut
        );
        if (isEmpty(uiElement)) return;
        uiEleMedia = uiElement.media || {};
        uiEleMedia.url = url;
        uiElement.media = uiEleMedia;
        this.updateStoryboardUIElementData(cloneDeep(uiElement));
        break;
      case 'ending':
        uiElement = getUIElement(storyboard.uiElements, getUIElementType().ending);
        if (isEmpty(uiElement)) return;
        uiEleMedia = uiElement.media || {};
        uiEleMedia.url = url;
        uiElement.media = uiEleMedia;
        this.updateStoryboardUIElementData(cloneDeep(uiElement));
        break;
      case 'storyboardMedia':
        const storyboardMedia = storyboard.media || { type: 'image', url: '' };
        storyboardMedia.url = media.url;
        storyboard.media = storyboardMedia;
        this.setState({ storyboard });
        break;
      default:
        break;
    }    
  }

  onDeleteSelectedPoi(category, id){
    const {storyboard} =cloneDeep(this.state);
    const { pois } = storyboard
    const index = pois.findIndex((p)=>id===p.id && category===p.category);
    if (index > -1) {
      pois.splice(index, 1);
     }

    storyboard.pois = pois
    this.setState({storyboard:storyboard})
  }

  updateStoryboardUIElementData(uiElement) {
    const { storyboard = {} } = cloneDeep(this.state);
    let { uiElements = [] } = storyboard;
    const { type = '', subType = '' } = uiElement;
    uiElements = uiElements ? uiElements : [];
    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) {
        return ele.type === type && ele.subType === subType;
      } else return ele.type === type && isEmpty(ele.subType);
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);

    storyboard.uiElements = uiElements;
    this.setState({
      storyboard,
    });
  }

  onChangeStoryboardText(key, event) {
    let storyboard = this.state.storyboard;
    const value = event.target.value;

    storyboard[key] = value;

    this.setState({
      storyboard,
    });
  }

  onUploadStoryboardMedia = e => {
    if (!e.target) return null;
    const { files = [] } = e.target;
    const mediaFor = {
      ui: getMediaForUIName().storyboard,
      name: 'storyboardMedia',
      s3FolderName: 'generic',
    };
    const { uploadMediaFunc } = this.props;
    const { storyboard } = this.state;
    const { media } = storyboard;
    uploadMediaFunc(mediaFor, media.type || '', files[0] || {});
  };

  onUploadACUIElementMedia = (name, s3FolderName, mediaType, file) => {
    const mediaFor = { ui: getMediaForUIName().storyboard, name: name, s3FolderName: s3FolderName };

    this.props.uploadMediaFunc(mediaFor, mediaType, file);
  }; 

  onChangeACUIElement = (uiElement) => {
    this.updateStoryboardUIElementData(uiElement);
  };

  onChangePoi = (poi, category, currentValue) => {
    const {storyboard} =cloneDeep(this.state);
    const { pois } = storyboard

    if(currentValue){
      const index = pois.findIndex((p)=>currentValue.value===p.id && category===p.category);
        pois[index] = {
          category:category,
          id:poi.value
        };
    }else{
      pois.push({
        category:category,
        id:poi.value
      })
    }


   const nonEmpty = pois.filter((poi)=>poi.id !== '')
   storyboard.pois = nonEmpty
   this.setState({storyboard:storyboard}) 
  };

  onUpdateCategory(from, toName) {
    const {storyboard } = cloneDeep(this.state);
    const { pois } = storyboard;
    if (toName === addNewCategorylabel || isEmpty(toName)) return null;
    const categories = this.getCategories(pois);
    if(categories.includes(from)){
      pois.forEach((poi)=>{
          if(poi.category===from){
            poi.category = toName
          }
      })
    }else{
      pois.push({
        category:toName,
        id:''
      })
    }
    storyboard.pois = pois;
    this.setState({storyboard:storyboard})
  }

  getCategories(pois) {
    let categories = [];

    if (!isEmpty(pois)) {
      pois.forEach((poi) => {
        if (!isEmpty(poi.category)) {
          if (indexOf(categories, poi.category) < 0) {
            categories.push(poi.category);
          }
        } else {
          // Make an unsorted category for all POIs that don't have a category.
          if (indexOf(categories, dummyCategoryName) < 0) {
            categories.push(dummyCategoryName);
          }
        }
      });
    }

    return categories;
  }

  renderCallOut() {
    const mediaFor = 'generic';
    const { storyboard = {} } = cloneDeep(this.state);
    const { uiElements } = storyboard;
    const callOut = getUIElement(uiElements, getUIElementType().callOut);
    const { media = {} } = callOut;
    if (isEmpty(media.type)) media.type = 'image';
    callOut.media = media;
    return (
      <div style={{marginTop:'20px'}}>
      <span className={styles.title}>Call Out</span> 
      <div className={styles.section}>
        <ACUIElement
          name="callOut"
          mediaName="storyboardCallOut"
          mediaFor={mediaFor}
          uiElement={callOut}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          isMediaTypeDisabled={true}
        />
      </div>
      </div>
    );
  }

  renderEnding() {
    const { storyboard = {} } = cloneDeep(this.state);
    const mediaFor = 'generic';
    const { uiElements } = storyboard;
    const ending = getUIElement(uiElements, getUIElementType().ending);
    const { media = {} } = ending;
    if (isEmpty(media.type)) media.type = 'image';
    ending.media = media;

    const endingCallOut = getUIElement(
      uiElements,
      getUIElementType().ending,
      getUIElementType().callOut
    );

    return (
      <div style={{  overflow: "auto",paddingBottom:"50px"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:'space-between'}}>
        <p className={styles.title}>Ending</p>
        {!this.state.showEnding &&<ACButton
              text={'Add Ending'}
              icon={<AddCircleOutlineIcon />}
              onClickFunc={() => this.setState({showEnding: true})}
            />}
          </div>
        {this.state.showEnding &&
        <div style={{backgroundColor:"white"}}>
        <ACUIElement
          name="ending"
          mediaName="storyboardEnding"
          mediaFor={mediaFor}
          uiElement={ending}
          showMedia={true}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
        <div>
        <div className={styles.title} style={{paddingTop:'20px',paddingLeft:"10px"}}>Call Out</div>
        <ACUIElement
          name="endingCallOut"
          mediaName="storyboardEndingCallOut"
          mediaFor={mediaFor}
          uiElement={endingCallOut}
          showBody={false}
          onChangeACUIElementFunc={this.onChangeACUIElement}
          onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
        />
        </div>
        </div>
        }
      </div>
    );
  }

renderPoisSegment() {
    const {storyboard} = cloneDeep(this.state);
    console.log(storyboard,"storyboard")
    const { pois } = this.props;
    let mpois = [];
    let cpois = [];

    if (!isEmpty(pois)){
    pois.forEach((p) => {
        mpois.push({
          label: p.name,
          value: p.id,
        });

      return null
    });
  }
    const catergoriesArray = this.getCategories(storyboard.pois);
    if(!isEmpty(catergoriesArray)){
      catergoriesArray.forEach((category)=>{
        let ids = []
        storyboard.pois.map((poi)=>{
          if(category === poi.category && poi.id!==''){
            ids.push(poi.id)
          }
          return null  
         })
         ids.push('')
         cpois.push({
          category:category,
          ids:ids
          
        })
      })
    }

    cpois.push({
      category:'Add New Category',
      ids:[]      
    })


    return (
      <div>
        {cpois.map((val)=>{
          
          
          return(
            <>
            <ACCategory
              key={[this.props.providerId, 'new-category'].join('_')}
              label={val.category}
              onUpdateTextFunc={(from, to) => {
              this.onUpdateCategory(from,to)}}
            />

          {val.ids.length>0 ? val?.ids?.map((id,index)=>{
           const selectedValue = mpois.find((val)=>val.value===id );
           const selectedPoisInfo =pois.find((p)=>p.id===id)
            return(
              <div>
              <div style={{ width: '100%', display:'flex',justifyContent:"leftAlign",marginTop:"10px" }}>
                <div style={{ width: '80%' }}>
              
                  <Select
                    className={styles.poisSelect}
                    inputId={`react-select-single-${id}`}
                    styles={{
                      // Fixes the overlapping problem of the component
                      menu: provided => ({ ...provided, zIndex: 3 })
                    }}
                    TextFieldProps={{
                      label: 'Select a Poi',
                      InputLabelProps: {
                      htmlFor: 'react-select-single',
                      shrink: true,
                      }                    }}
                    placeholder={'Select a POI'}
                    options={mpois}
                    value={selectedValue?selectedValue:'Select a POI'}
                    onChange={(event)=>{this.onChangePoi(event,val.category,selectedValue)}}
                  />
                </div>
                {selectedValue?.value ? 
                <div
                  style={{ marginLeft: 'auto', marginRight: '0px',width:'20%',justifyContent:"end",alignItems:"center",display:'flex' }}
                  onClick={()=>{this.onDeleteSelectedPoi(val.category,id)}}
                  >
                  <DeleteIcon
                    style={{
                    color: '#FF765F',
                    cursor: 'pointer',
                    }}
                  />
                </div>:''}

              </div>
              {selectedValue?.value ?
              <span style={{
                    fontSize: "12px",
                    color: "#434F69",
                    marginLeft: "5px"}}
              >{selectedPoisInfo?.text ? selectedPoisInfo?.text:"No information available"}</span>:""}
              </div>)
          }
          ) :
          <div style={{ width: '80%',marginRight:'50px' }}>   
            <Select
              className={styles.poisSelect}
              inputId={`react-select-single`}
              TextFieldProps={{
                label: 'Select a Poi',
                InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
                }
              }}
              placeholder={'Select a POI'}
              options={mpois}
              value={" "}
              onChange={(event)=>{
                this.onChangePoi(event,val.category)   
              }}
          />
        </div>
        }    
          </>
          )
        })}
      </div>
    );
  }

  renderPois() {
    return (
      <div style={{paddingBottom:'50px'}}>
          <div className={styles.title}>
            Build Your Stack
            <div style={{ width: '97%' }}>
            {this.renderPoisSegment()}
            </div>
        </div>
      </div>
    );
  }

  onSaveStoryboard() {
    let storyboard = this.state.storyboard;
    let nonEmpty =[];
    if(storyboard.pois){
      nonEmpty = storyboard?.pois.filter((poi)=>poi.id !== '')
    }
    storyboard.pois = nonEmpty
    this.props.onSaveStoryboardFunc(storyboard);
    this.props.onCloseFunc();
  }

  render() {
    const { storyboard } = cloneDeep(this.state);
    const { media = { type: 'image', url: '' } } = storyboard;
    if (isEmpty(storyboard)) return null;

    return (
      <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>     
                <div>
                  <h3>Set Storyboard</h3>
                </div>           
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={this.props.onCloseFunc} />
                </div>
              </div>
              <div className={styles.middle}>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span className={styles.title}>Details</span>
                    <ACStatus
                      type="provider"
                      status={storyboard.status}
                      isEditable={true}
                      onChangeFunc={(e) => this.onChangeStoryboardText('status', e)}
                    />
                  </div>                  
                  <div>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            Name
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={storyboard.name}
                      onChange={(e) => this.onChangeStoryboardText('name', e)}
                    />
                    <TextField
                      multiline
                      rows={4}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment style={{alignSelf: "baseline"}} position="start" className={styles.adornment}>
                            Internal Note
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={storyboard.internalNote}
                      onChange={e => this.onChangeStoryboardText('internalNote', e)}
                    />
                    <ACMedia
                      name="storyboardMedia"
                      media={media}
                      accept="image/*"
                      onUploadMediaFunc={this.onUploadStoryboardMedia}
                      isMediaTypeDisabled={true}
                    />
                    <div style={{marginTop:'20px'}} >
                    <div style={{marginBottom:'20px'}}>
                     <span className={styles.title} >Bio</span> 
                    </div>
                    
                    <TextField
                      value={storyboard.bio}
                      style={{backgroundColor:'white'}}
                      className={styles.note}
                      onChange={(e) => this.onChangeStoryboardText('bio', e)}
                      multiline
                      rows="15"
                    />
                    {this.renderCallOut()}
                    </div>
                  </div>
                </div>
              </div>    
              {this.renderPois()}          
              {this.renderEnding()}    
              <div className={styles.bottom}>
                <ACButton
                  text={'Save'}
                  icon={<SaveIcon />}
                  iconLast={true}
                  onClickFunc={this.onSaveStoryboard}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
